import React from 'react';
import gbPng from './flags/gb.png';
import germanyPng from './flags/germany.png';
import japanPng from './flags/japan.png';
import russiaPng from './flags/russia.png';

const FLAGS_MAP = {
  'en-gb': { src: gbPng, alt: 'Flag of GB' },
  'de-de': { src: germanyPng, alt: 'Flag of Germany' },
  'ja-jp': { src: japanPng, alt: 'Flag of Japan' },
  'ru-ru': { src: russiaPng, alt: 'Flag of Russia' },
};

export const renderFlag = (locale) => {
  const flagProps = FLAGS_MAP[locale];
  if (!flagProps) return null;
  return <img style={{ height: '100%' }} {...flagProps} />;
};
